import { h } from 'preact'
import { useSelector } from 'react-redux'
import PagePrice from '../../PagePrice'
import { transactionDetailsSelector } from '../../../redux/slice/transactionDetailsSlice'
import { useTranslations } from '../../../hooks/useTranslations'
import './styles.scss'

const PaymentPricePerPerson = () => {
  const { amount, currency, overrideAmount, numberOfPassengers, culture } =
    useSelector(transactionDetailsSelector)

  const l10n = useTranslations()

  const pricePerPerson = (overrideAmount || amount) / numberOfPassengers

  return (
    <tui-payments-price-per-person
      className="payment-price price-per-person mfe-component"
      data-testid="price-per-person"
    >
      <PagePrice
        {...{ amount: pricePerPerson, currency, culture }}
        className="small"
      />
      <div className="price-per-person__explanation">{l10n.t('pp')}</div>
    </tui-payments-price-per-person>
  )
}

export default PaymentPricePerPerson
